import React,{useState} from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Products from './pages/Products';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
// import UpdateProfile from './pages/UpdateProfile';
import AboutUs from './pages/AboutUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FAQ from './pages/FAQ';
import Terms from './pages/Terms';
import Devices from './pages/Devices';
import Medicines from './pages/Medicines';
import Personal from './pages/Personal';
import Wellness from './pages/Wellness';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import BookingSuccess from './pages/BookingSuccess';
import BookPharmacist from './pages/BookPharmacist'; // Adjust path if needed
import MedicineDetail from './pages/MedicineDetail'; // Adjust path if needed
import DeviceDetail from './pages/DeviceDetail';
import PersonalDetail from './pages/PersonalDetail';
import WellnessDetail from './pages/WellnessDetails';
import Cart from './pages/Cart';
import Profile from './pages/Profile';
import UpdateProfile from './pages/UpdateProfile';
function App() {
  const [user, setUser] = useState(null);
  return (
    <Router>
      <Navbar user={user}/>
            <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/login" element={<Login setUser={setUser}/>} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/book-pharmacist" element={<BookPharmacist />} />
        <Route path="/booking-success" element={<BookingSuccess />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/devices" element={<Devices />} />
    <Route path="/medicines" element={<Medicines />} />
    <Route path="/medicines/:id" element={<MedicineDetail />} />
    <Route path="/devices/:id" element={<DeviceDetail />} />
    <Route path="/personal/:id" element={<PersonalDetail />} />
    <Route path="/wellness/:id" element={<WellnessDetail />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/personal" element={<Personal />} /> 
        <Route path="/wellness" element={<Wellness />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/update-profile" element={<UpdateProfile setUser={setUser} />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
